import React from 'react';
import { rem } from 'polished';
import styled from 'styled-components';
import moment from 'moment';
import { __, formatDate } from '../../../../Utils';
import { connect, actions } from '../../../../Store';
import BaseList from '../../BaseList';
import { FlexBox } from '../../../../Components/ReusableComponents';
import IconTd from '../../../../Components/ReusableComponents/IconTd';
import AlertPopup from '../../../../Components/AlertPopup';
import ProductQuantitySelect from '../../../../Components/ProductQuantitySelect';
import API2 from '../../../../API2';

const P = styled.p`
  margin: 0;
  padding: 0 ${rem(10)};
  font-size: ${({ theme }) => theme.font.fontSizeXS};
`;

class Campaigns extends BaseList {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      doNotLoadFilters: true,
      title: __('Kampane'),
      notFoundMessage: __('Momentálne nie sú aktívne žiadne kampane'),
      isProduct: true,
      maxFilterWidth: 140,
      displayedColumns: {},
      defaultFilter: [],
    };

    actions.setActiveMenuItem('44');
  }

  componentDidMount() {
    const {
      actualPage,
      checkedFilter,
      offset,
      nextOffset,
      total,
    } = this.loadActualData();

    this.setState(
      {
        loading: true,
        searchText: this.props.match.params.q,
        actualPage:
          actualPage &&
          actualPage !== null &&
          actualPage !== 'null' &&
          actualPage > 0
            ? Number(actualPage)
            : 1,
        offset:
          offset && offset !== null && offset !== 'null' && offset > 0
            ? Number(offset)
            : 0,
        nextOffset:
          nextOffset &&
          nextOffset !== null &&
          nextOffset !== 'null' &&
          nextOffset > 0
            ? Number(nextOffset)
            : 0,
        total:
          total && total !== null && total !== 'null' && total > 0
            ? Number(total)
            : 0,
        checkedFilter: [],
      },
      async () => {
        await this.fetchFilter(!checkedFilter || checkedFilter.length === 0);
        await this.fetchData();
        this.setTableHeight();
        this.saveActualData(1, 0, null, [], null);
      },
    );
  }

  async fetchData(parameters = {}) {
    try {
      const { searchText } = this.state;
      this.setState({ loading: true, showProductAddedPopup: false });
      const params = parameters;

      if (searchText && searchText.length > 0) {
        params.q = searchText;
      }

      const newData = await API2.getB2BCustomerCampaignsAction(params);

      this.setState({
        tableItems: newData.campaigns,
        loading: false,
        filtersDisabled: false,
        limit: newData.limit,
        offset: newData.offset,
        total: newData.total,
        nextOffset: newData.next_offset,
      });
      this.setState({ loading: false });
    } catch (e) {
      this.setState({ error: __('Nepodarilo sa načítať produkty') });
    }
  }

  handleSorter(s) {
    const { sorter } = this.state;
    let newSorter = sorter;
    switch (s) {
      case __('NÁZOV KAMPANE'):
        if (sorter === 'name') {
          newSorter = '-name';
        } else {
          newSorter = 'name';
        }
        break;
      case __('ALTERNATÍVA'):
        if (sorter === 'campaign_alternative') {
          newSorter = '-campaign_alternative';
        } else {
          newSorter = 'campaign_alternative';
        }
        break;
      case __('PLATÍ OD'):
        if (sorter === 'valid_from') {
          newSorter = '-valid_from';
        } else {
          newSorter = 'valid_from';
        }
        break;
      case __('PLATÍ DO'):
        if (sorter === 'valid_to') {
          newSorter = '-valid_to';
        } else {
          newSorter = 'valid_to';
        }
        break;
      case __('PUBLIKOVANÁ OD'):
        if (sorter === 'publish_from') {
          newSorter = '-publish_from';
        } else {
          newSorter = 'publish_from';
        }
        break;
      case __('PUBLIKOVANÁ DO'):
        if (sorter === 'publish_to') {
          newSorter = '-publish_to';
        } else {
          newSorter = 'publish_to';
        }
        break;
      default:
        newSorter = '';
        break;
    }

    this.setState({ sorter: newSorter }, () => this.fetchData());
  }

  onRowClicked(index) {
    const { tableItems } = this.state;
    const campaignId = tableItems[index]._id;
    this.props.history.push(`/buy/products?campaign=${campaignId}`);
  }

  setTableHeight() {
    if (this.pager && this.mainWrapper && this.segment) {
      const tableHeight = window.innerHeight - 600;

      this.setState({ tableHeight });
    }
  }

  createColumns(sorter) {
    const result = [
      {
        sortable: true,
        accessor: 'name',
        Header: () => (
          <IconTd
            sorter={sorter === 'name' || sorter === '-name' ? sorter : null}
          >
            {__('NÁZOV KAMPANE')}
          </IconTd>
        ),
        Cell: props => {
          return <P>{props.value}</P>;
        },
      },
    ];

    result.push({
      sortable: true,
      accessor: 'valid_from',
      Header: () => (
        <IconTd
          sorter={
            sorter === 'valid_from' || sorter === '-valid_from' ? sorter : null
          }
        >
          {__('PLATÍ OD')}
        </IconTd>
      ),
      Cell: props => {
        return <P>{formatDate(moment(props.value))}</P>;
      },
    });

    result.push({
      sortable: true,
      accessor: 'valid_to',
      Header: () => (
        <IconTd
          sorter={
            sorter === 'valid_to' || sorter === '-valid_to' ? sorter : null
          }
        >
          {__('PLATÍ DO')}
        </IconTd>
      ),
      Cell: props => {
        return <P>{formatDate(moment(props.value))}</P>;
      },
    });

    // result.push({
    //   sortable: true,
    //   accessor: 'publish_from',
    //   Header: () => (
    //     <IconTd
    //       sorter={
    //         sorter === 'publish_from' || sorter === '-publish_from'
    //           ? sorter
    //           : null
    //       }
    //     >
    //       {__('PUBLIKOVANÁ OD')}
    //     </IconTd>
    //   ),
    //   Cell: props => {
    //     return <P>{formatDate(moment(props.value))}</P>;
    //   },
    // });

    // result.push({
    //   sortable: true,
    //   accessor: 'publish_to',
    //   Header: () => (
    //     <IconTd
    //       sorter={
    //         sorter === 'publish_to' || sorter === '-publish_to' ? sorter : null
    //       }
    //     >
    //       {__('PUBLIKOVANÁ DO')}
    //     </IconTd>
    //   ),
    //   Cell: props => {
    //     return <P>{formatDate(moment(props.value))}</P>;
    //   },
    // });

    result.push({
      name: '',
      Header: '',
      accessor: '_id',
      Cell: () => <FlexBox style={{ height: rem(40) }} />,
    });

    return result;
  }

  render() {
    const { showAddToCart, tableItems, productToAddIndex } = this.state;

    return (
      <React.Fragment>
        <AlertPopup
          display={showAddToCart}
          alignUnderHeader
          onClose={() =>
            this.setState({
              showAddToCart: false,
            })
          }
          component={
            <ProductQuantitySelect
              items={
                tableItems &&
                tableItems[productToAddIndex] &&
                tableItems[productToAddIndex].Unit_of_Measure
              }
              onSubmit={quantity => this.addToCard(quantity)}
            />
          }
        />
        {super.render()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(Campaigns);



// WEBPACK FOOTER //
// ./src/Containers/Buy/Campaings/List/index.jsx